import React from 'react';
import { CONTRACT_DISCLAMER_TEXT } from '../../../brands/default/content/components/checkout';

const VoucherContractDisclamer = () => {
  return (
    <>
      <div className="voucher-contract-disclamer">
        {CONTRACT_DISCLAMER_TEXT}
      </div>
      <style jsx>{`
        .voucher-contract-disclamer {
          font-size: 11px;
          margin: 0 10px 10px 10px;
          text-align: justify;
        }
      `}</style>
    </>
  );
};

export default VoucherContractDisclamer;
